<script>
import { Router, Link, Route, link, navigate } from "svelte-routing";
const { jsPDF } = window.jspdf;
import Header from "../components/header.svelte"
import Cardclient from "../components/cardClients.svelte"
import { isUserDbAdmin} from './stores.js';
import Jouet from "../components/jouet.svelte"
import { each } from "svelte/internal";


export let db;
export let auth;

export let location;
  location = location;

  const increment = firebase.firestore.FieldValue.increment(1);
const decrement = firebase.firestore.FieldValue.increment(-1);
function jincremente(a){
  return firebase.firestore.FieldValue.increment(a);
}
function jdecremente(a){
  return firebase.firestore.FieldValue.increment(-a);
}
/* Pour envoi email

var Email = { send: function (a) { return new Promise(function (n, e) { a.nocache = Math.floor(1e6 * Math.random() + 1), a.Action = "Send"; var t = JSON.stringify(a); Email.ajaxPost("https://smtpjs.com/v3/smtpjs.aspx?", t, function (e) { n(e) }) }) }, ajaxPost: function (e, n, t) { var a = Email.createCORSRequest("POST", e); a.setRequestHeader("Content-type", "application/x-www-form-urlencoded"), a.onload = function () { var e = a.responseText; null != t && t(e) }, a.send(n) }, ajax: function (e, n) { var t = Email.createCORSRequest("GET", e); t.onload = function () { var e = t.responseText; null != n && n(e) }, t.send() }, createCORSRequest: function (e, n) { var t = new XMLHttpRequest; return "withCredentials" in t ? t.open(e, n, !0) : "undefined" != typeof XDomainRequest ? (t = new XDomainRequest).open(e, n) : t = null, t } };

Fin email*/

var user = auth.currentUser;
var is_Admin = false;

var  listUsers = [];
var  listYes = [];
var  listNo = [];
var  listPending = [];
var req = false;

let filters = 1;


//POur modifier
var formnew;
var name;
var descriptif;
var categorie;
var sub_categorie;
var prix;


var ArticlesCurrent = []
var userCurrent;
var good = false;

function goPanier(){
  navigate("/panier", { replace: false });
}
function goClients(){
  navigate("/clients", { replace: false });
}
function goListe(){
  navigate("/user", { replace: false });
}
function goJouets(){
  navigate("/jouets", { replace: false });
}

function logout(){
  auth.signOut().then(() => {
    user = undefined;
    navigate("/", { replace: false });
    window.location.reload()
}).catch((error) => {
  // An error happened.
});
}

var stats = {}
   stats.nbArticles = 0
   stats.nbVendeurs = 0
   stats.participation = 0
   stats.montantTotal = 0
   stats.nbVendus = 0
   stats.montantVendu = 0


   var storedUser;

const unsubscribe = isUserDbAdmin.subscribe(value => {
		storedUser = value;
	});
   
   auth.onAuthStateChanged(function(user) {
  if (user) {
    user = auth.currentUser
    if(!storedUser){
          console.log("n'a pas été determiné si admin")
          db.collection("admins").doc(user.uid).get().then((doc) => {
            
            if (doc.exists) {
                  isUserDbAdmin.set({admin:true,name:doc.data().Nom});
                  is_Admin = true
              } else {
                  isUserDbAdmin.set({admin:false})
              }
          }).catch((error) => {
              console.log("Error getting document:", error);
          });;
        }
    if(storedUser.admin == true){
         is_Admin = true
       }


  } else {
    // No user is signed in.
  }
});


    function getUsers(){
      req = false
      listUsers = []
      listPending = []
      listYes = []
      listNo = []
      let nbUserWithJouets = 0;
      db.collection("users")
    .get()
    .then((querySnapshot) => {
        let nbValid = 0
        querySnapshot.forEach((doc) => {
          var temp = doc.data()
          temp.id = doc.id
          listUsers.push(temp)
          console.log(temp.email)
          if(temp.nbJouets >0){
            nbUserWithJouets+=1
          }

          if(temp.statut == "no"){
            listNo.push(temp)
          }
          if(temp.statut == "pending"){
            listPending.push(temp)
          }
          if(temp.statut == "yes"){
            nbValid+=1
            listYes.push(temp)
          }
          stats.nbVendeurs +=1;
          stats.nbArticles += doc.data().nbJouets
          stats.participation += doc.data().prixTotal
          stats.montantTotal += doc.data().prixTotal
          stats.nbVendus += doc.data().nbVendus
          stats.montantVendu += doc.data().gain
        });
        //console.log("nb with jouets : "+nbUserWithJouets)
        //console.log("avant")
        //magicfix()
        //console.log("apres")
        console.log(nbValid)
        req = true;
        handleFilter();
    })
    .catch((error) => {
        console.log("Error getting documents: ", error);
    });
    }
    
  getUsers()

    function sendMail(){
      var texte = "Bonjour " + userCurrent.name + " " + userCurrent.sirname + ",<br><br>"
      texte += "L'équipe de la bourse aux jouets et de la puériculture du Perreux/Marne à le plaisir de vous confirmer que votre heure de rendez-vous ainsi que votre liste d'articles ont été validées.<br> "
      texte += "Vous pouvez désormais vous rendre sur votre espace client afin de générer et d'imprimer votre liste d'étiquettes.<br>"
      texte += "On vous attends le "+ userCurrent.rdv + " afin que vous puissez déposez vos jouets. Nous vous rappelons que des frais de 10% sont à votre charge lors de la dépose, selon votre liste, ils s'élèvent à " + (userCurrent.prixTotal*0.1).toFixed(2) + "€.<br><br>"
      texte += "A bientot, l'equipe de la bourse aux jouets et de la puériculture."
      Email.send({
    Host : "smtp.gmail.com",
    Username : "baj.leperreux@gmail.com",
    Password : "$BourseJouetsLePerreux2021!",
    To : userCurrent.email,
    From : "baj.leperreux@gmail.com",
    Subject : "[BAJ] Liste confirmée",
    Body : texte
}).then(()=>{
  console.log("Mail envoyé à : ",userCurrent.email)
  let userRef = db.collection('users').doc(userCurrent.id);
   userRef.update({ statut:"yes" }).then(()=>{
    getUsers()
    userCurrent.statut = "yes"
   })
   
  });
     
    }

    function makeListe(){
      const doc = new jsPDF();
      doc.rect(104,47, 2, 240, "F")
      doc.rect(0,10, 210, 1, "F")
      for(var i=0;i<21;i++){
        doc.rect(0,12*i+47, 210, 1, "F")
      }
      var don = userCurrent.don ? "OUI" : "NON"
      doc.text(userCurrent.name,5,20)
      doc.text(userCurrent.sirname,50,20)
      doc.text("Don : "+don,100,20)
      doc.text(userCurrent.noInscrit,165,20)
      doc.text(userCurrent.email,5,31)
      doc.text("Tel : " + userCurrent.tel,85,31)
      doc.text("RDV : "+userCurrent.rdv,140,31)
      doc.text("Participation : "+(userCurrent.prixTotal*0.1).toFixed(2)+"€",5,42)
      doc.text("Total : "+userCurrent.prixTotal+"€",85,42)
      doc.text("Nombres d'articles : "+ userCurrent.nbJouets,140,42)
      
      let articlesUser = []
      db.collection("jouets").where("owner_id", "==", userCurrent.id)
    .get()
    .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
            articlesUser.push(doc.data())
        });

        console.log("articlesUser",articlesUser)
        articlesUser.forEach(jouet => {
          console.log(articlesUser.indexOf(jouet)<=19)
        if(articlesUser.indexOf(jouet)<=19){
          var x = 5
          var y = articlesUser.indexOf(jouet)*12+57
          doc.text((articlesUser.indexOf(jouet)+1) + ". " + jouet.name,x,y)
          x = 70
          doc.text("Prix : " + jouet.prix+"€",x,y)
        }else{
          var x = 110
          var y = (articlesUser.indexOf(jouet)-20)*12+57
          doc.text((articlesUser.indexOf(jouet)+1) + ". " + jouet.name,x,y)
          x = 180
          doc.text("Prix : " + jouet.prix+"€",x,y)
        } 
      });
      doc.save(userCurrent.sirname)
    })
    .catch((error) => {
        console.log("Error getting documents: ", error);
    });
      
      

      
    }
    function goRdv(){
  navigate("/rdv", { replace: false });
}

function cancel(){
  let userRef = db.collection('users').doc(userCurrent.id);
   userRef.update({ statut:"no" }).then(()=>{
    getUsers()
    userCurrent.statut = "no"
   })
}

var listeDefusers = listUsers;

function handleFilter(){
  req = false;
  if(filters == 1){
    listeDefusers = listUsers
  }else if(filters == 2){
    listeDefusers = listYes
  }else if(filters == 3){
    listeDefusers = listPending
  }else if(filters == 4){
    listeDefusers = listNo
  }
  req = true;
}

function showArticles(user){
  ArticlesCurrent = []
  good = false;
  userCurrent = user;
  db.collection("jouets").where("owner_id", "==", user.id)
    .get()
    .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
            let temp = doc.data()
            temp.id = doc.id
            ArticlesCurrent.push(temp)
        });
        //apres recup les jouets la requete good est true
        good = true;
    });
}

function removeJouet(event){
  var id = event.detail.id
  let leJouet = event.detail.jouet
  console.log("delete",id)
  db.collection('jouets').doc(id).get().then((doc)=>{
    let userRef = db.collection('users').doc(userCurrent.id);
   userRef.update({ nbJouets: decrement,prixTotal: jdecremente(doc.data().prix) }).then(()=>{
    userCurrent.nbJouets-=1;
    userCurrent.prixTotal-=doc.data().prix;
    db.collection('jouets').doc(id).delete().then(()=>{
      
      showArticles(userCurrent)
      getUsers()
      handleFilter()
    })
});
   });
}


var editID;

function showNew(){
        formnew.style.display = "flex";
    }


function editJouet(event){
  var id = event.detail.id
  editID = id;
  let leJouet = event.detail.jouet
  name = leJouet.name;
  descriptif = leJouet.descriptif;
  categorie = leJouet.categorie;
  sub_categorie = leJouet.sub_categorie;
  prix = leJouet.prix;
  formnew.style.display = "flex";
}

function editJouetGood(){
  console.log("edit",editID)
  console.log("new cat " + categorie)
  console.log("new sub " + sub_categorie)
  db.collection('jouets').doc(editID).get().then((doc)=>{
  let data = doc.data();
  let userRef = db.collection('users').doc(userCurrent.id);
   userRef.update({prixTotal: jdecremente(doc.data().prix) }).then(()=>{
    userCurrent.prixTotal-=doc.data().prix
    userRef.update({prixTotal: jincremente(prix) }).then(()=>{
      userCurrent.prixTotal+=prix
      db.collection('jouets').doc(editID).update({
        name: name,
        descriptif: descriptif,
        categorie: categorie,
        sub_categorie: sub_categorie,
        prix: prix
      }).then(()=>{
          name = "";
          descriptif = "";
          categorie = "ACTIVITES MANUELLES";
          sub_categorie = "ARDOISE MAGIQUE";
          prix = 0;
          editID = "";
          formnew.style.display = "none"
          showArticles(userCurrent)
      });


    });
    
  });
   });
}

function compare(a,b) {
  if (a.rdv < b.rdv)
     return -1;
  if (a.rdv > b.rdv)
    return 1;
  return 0;
}


function listing(){
  const listing = new jsPDF();
  let users = [];
  db.collection("users")
    .get()
    .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          users.push(doc.data())
        });
        let usersWithRdv = users.filter(rdv => rdv.rdv != "");
        let usersWithRdvSorted = usersWithRdv.sort(compare);
        let heures = []
        usersWithRdvSorted.forEach(user => {
          if(!heures.includes(user.rdv.replace(" ","").split('-')[1])){
            heures.push(user.rdv.replace(" ","").split('-')[1])
          }
        });
        listing.setFontSize(22)
        listing.text("Listing RDV",20,15)
        listing.setFontSize(14)
        let x = 10;
        let y = 30;
        heures.forEach(heure => {
          listing.text(heure + " : ",x,y)
          x+=2
          y+=2
          listing.line(x,y,x+130,y,'FD')
          y+=10;
          if(y>277){
            listing.addPage()
            listing.setFontSize(14)
             y = 15;
          }
          let userHeure = usersWithRdvSorted.filter( user => user.rdv.replace(" ","").split('-')[1] == heure )
          userHeure.forEach(user => {
            x = 40
            let clientName = user.sirname.charAt(0).toUpperCase() + user.sirname.slice(1);
            listing.text("• " +clientName,x,y)
            listing.text("Tel :", x+65,y)
            listing.text(user.tel, x+75,y)
            y+=10;
            if(y>277){
            listing.addPage()
            listing.setFontSize(14)
             y = 15;
          }
          x = 10
          });
        });
        usersWithRdvSorted.forEach(user => {
        });
        listing.save("Listing RDV")
    })

}



/*****************************           REPARATION         ******************************************/


function magicvendu(){
  let jouetsReelAll = 0
  listUsers.forEach(user => {
        let montantVenduReel = 0
    let nbJouetsVenduReel = 0
      db.collection("jouets").where("owner_id", "==", user.id)
    .get()
    .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
            if (doc.data().vendu){
              montantVenduReel += doc.data().prix
              nbJouetsVenduReel +=1
            }
        });
    console.log(user.email,user.nbVendus,user.gain,nbJouetsVenduReel,montantVenduReel)
    if(!(user.nbVendus == nbJouetsVenduReel && user.gain == montantVenduReel )){
      let userRef = db.collection('users').doc(user.id)
      console.log(userRef)
      userRef.update({
        nbVendus : nbJouetsVenduReel,
        gain : montantVenduReel
      }).then(()=> console.log(user.email,"BON"))
    }
  }).catch((error) => console.log(error))
   
}
  )}


  function magicfix(){
  listUsers.forEach(user => {
    let montantReel = 0
    let nbJouetsReel = 0
      db.collection("jouets").where("owner_id", "==", user.id)
    .get()
    .then((querySnapshot) => {
        let nblocal = 0
        querySnapshot.forEach((doc) => {
              montantReel += doc.data().prix
              nbJouetsReel +=1
              nblocal +=1
        });
        console.log(user.noInscrit + " " + nblocal)
        //console.log("nb user : " + user.nbJouets + " nb jouets : " + nbJouetsReel)
        //console.log("prix user : " + user.prixTotal + " prix jouets : " + montantReel)
    if(!(user.nbJouets == nbJouetsReel || user.prixTotal == montantReel )){
      let userRef = db.collection('users').doc(user.id)
      console.log(user.noInscrit)
      userRef.update({
        nbJouets : nbJouetsReel,
        prixTotal : montantReel
      }).then(()=> console.log(user.noInscrit + " " + user.email + " BON"))
    }
  }).catch((error) => console.log(error))
   
}
  )}






</script>



<main>
  <div class="cache"></div>

    <Header>
      <div on:click={logout} class="elm">Déconnexion</div>
      <div class="elm" on:click={goListe}>Ma liste 📃</div><br>
      <div class="elm" on:click={goRdv}>RDV ⏰</div>
      {#if is_Admin}
      <div class="elm" on:click={goJouets}>Articles 🧸</div>
      <div class="elm" on:click={goClients}>Vendeurs 👱‍♂️</div>
      <div class="elm" on:click={goPanier}>Panier 🛒</div>
        {/if}
      </Header>
      <!-- OLD
      <button class="btn-stat" on:click={()=>{document.querySelector('.stats').style.display = "flex";}}>Statistiques</button>
      <div class="container">
        {#if req}
        {#each listUsers as user}
        <Cardclient {user} on:send={sendMail} on:cancel={cancel} on:pdf={makeListe}></Cardclient>
        {/each}
        {/if}
      </div>
      <div class="stats" on:click|self={()=>{document.querySelector('.stats').style.display = "none";}}>
        <div style="font-size: 3rem;font-family: 'Poppins', sans-serif;font-weight: 700;margin-bottom: 10vh;text-decoration: underline;">Statistiques</div>
        <div class="stat">• Nombre de vendeurs : {stats.nbVendeurs}</div>
        <div class="stat">• Nombre d'articles : {stats.nbArticles}</div>
        <div class="stat">• Participation total : {(stats.participation*0.1).toFixed(2)}€</div>
        <div class="stat">• Montant total des listes : {stats.montantTotal.toFixed(2)}€</div>
        <div class="stat">• Nombre d'articles vendus : {stats.nbVendus} ({(stats.nbVendus/stats.nbArticles*100).toFixed(2)}%)</div>
        <div class="stat">• Montant des paniers : {stats.montantVendu.toFixed(2)}€ ({(stats.montantVendu/stats.montantTotal*100).toFixed(2)}%)</div>
      </div>
      -->
      <div style="display: flex;">
        <div style="width: 20vw; height: 1px;"></div>
        <div class="filters">
          <label>
            <input type=radio bind:group={filters} value={1}>
            Tout
          </label>
          <label>
            <input  type=radio bind:group={filters} value={2}>
            Validé
          </label>
          <label>
            <input  type=radio bind:group={filters} value={3}>
            En attente
          </label>
          <label>
            <input type=radio bind:group={filters} value={4}>
            Non validé
          </label>
          <div class="apply" on:click={handleFilter}>✅</div>
        </div>
          <div class="users">
              
              <div class="usersbtn">
                {#if req}
                {#each listeDefusers as user}
                    <div on:click={()=>{showArticles(user)}} class="cardUser {user.statut == 'yes' ? "green" : user.statut == 'pending' ? "orange" : "red"}">
                        <div style="justify-self: flex-start;">{user.noInscrit}</div>
                        <div style="justify-self: flex-end;">{user.nbJouets}/40</div>
                    </div>
                {/each}
                {/if}
              </div>
          </div>

          {#if good}
        <div class="cont">
          
          <div class="infos">
            <div>
              <div>Vendeur : {userCurrent.name} {userCurrent.sirname}</div>
              <div>Code vendeur : <b>{userCurrent.noInscrit}</b></div>
              <div>Heure de rdv : {userCurrent.rdv}</div>
            </div>
            <div>
              <div>{userCurrent.email}</div>
              <div>Nombre de jouets : {userCurrent.nbJouets}/40</div>
            </div>
            <div>
              <div>Montant total de la liste : {userCurrent.prixTotal.toFixed(2)}€</div>
              <div>Participation : {(userCurrent.prixTotal*0.1).toFixed(2)}€ (10%)</div>
            </div>
            <div>
              <div>Jouets vendus : {userCurrent.nbVendus}/{userCurrent.nbJouets}</div>
              <div>Gain : {userCurrent.gain.toFixed(2)}€</div>
            </div>
            <div>
              {#if userCurrent.statut == "pending"}
                  <div on:click={cancel} class="btn-cancel">Invalider</div>
                  <div on:click={sendMail} class="submit">Valider</div>
              {:else if userCurrent.statut == "yes"}
                  <div on:click={makeListe} class="submit">Liste</div>
              {/if}
            </div>
                       
          </div>
          
          <div class="jouetsContainer">
              {#each ArticlesCurrent as jouet }
              <Jouet {jouet} showVendu={jouet.vendu} on:remove={removeJouet} on:edit={editJouet}></Jouet>
              {/each}
          </div>
          
        </div>
        {:else}
          <div class="stats">
            <div style="font-size: 3rem;font-family: 'Poppins', sans-serif;font-weight: 700;margin-bottom: 10vh;text-decoration: underline;">Statistiques</div>
            <div class="stat">• Nombre de vendeurs : {stats.nbVendeurs}</div>
            <div class="stat">• Nombre d'articles : {stats.nbArticles}</div>
            <div class="stat">• Participation total : {(stats.participation*0.1).toFixed(2)}€</div>
            <div class="stat">• Montant total des listes : {stats.montantTotal.toFixed(2)}€</div>
            <div class="stat">• Nombre d'articles vendus : {stats.nbVendus} ({(stats.nbVendus/stats.nbArticles*100).toFixed(2)}%)</div>
            <div class="stat">• Montant des paniers : {stats.montantVendu.toFixed(2)}€ ({(stats.montantVendu/stats.montantTotal*100).toFixed(2)}%)</div>
            <button class="btn-stat" on:click={listing}>Listing rdv</button>
          </div>
          {/if}
      </div>
     


      <!-- POUR MODIFIER UNIQUEMENT -->


      <div bind:this={formnew} class="cacheform" on:click|self={formnew.style.display = "none"}>
        <div  class="formjouet">
          <h2 style="font-family: 'Poppins', sans-serif;font-weight: 400;font-size:clamp(1rem, -0.875rem + 2.4vw, 3.5rem);">Nouvel article 🧸</h2>
          <form>
            <select name="jouet" id="categorie" bind:value={categorie}>
              <option value="ACTIVITES MANUELLES">Activites Manuelles</option>
              <option value="AUDIO / VIDEO">Audio / Video</option>
              <option value="JEUX DE SOCIETE">Jeux De Societe</option>
              <option value="JEUX EDUCATIF">Jeux Educatif</option>
              <option value="JEUX INTERACTIF">Jeux Interactif</option>
              <option value="JEUX PLEIN AIR">Jeux Plein Air</option>
              <option value="JEUX D’IMITATION">Jeux D’Imitation</option>
              <option value="JOUET 1ER AGE">Jouet 1Er Age</option>
              <option value="JOUET EN BOIS">Jouet En Bois</option>
              <option value="LECTURE">Lecture</option>
              <option value="PUZZLE">Puzzle</option>
              <option value="UNIVERS BEBE">Univers Bebe</option>
              <option value="UNIVERS BEBE NUIT">Univers Bebe Nuit</option>
              <option value="UNIVERS BEBE REPAS">Univers Bebe Repas</option>
              <option value="UNIVERS FILLE">Univers Fille</option>
              <option value="UNIVERS GARCON">Univers Garcon</option>
              </select>
      
            {#if categorie == "ACTIVITES MANUELLES"}
            <select name="sub_categorie" id="sub_categorie" bind:value={sub_categorie}>
            <option value="ARDOISE MAGIQUE">Ardoise Magique</option>
            <option value="BIJOUX">Bijoux</option>
            <option value="COUTURE / CREATION">Couture / Creation</option>
            <option value="CUISINE">Cuisine</option>
            <option value="DECOUPAGE">Decoupage</option>
            <option value="FEUTRE / PEINTURE ">Feutre / Peinture </option>
            <option value="MANDALA">Mandala</option>
            <option value="MAQUETTE / TAMPON">Maquette / Tampon</option>
            <option value="PATE A MODELER ">Pate A Modeler </option>
            <option value="PERLE / BRODERIE">Perle / Broderie</option>
            <option value="PLAYMAIS">Playmais</option>
            <option value="POTERIE">Poterie</option>
            <option value="PROJECTEUR A DESSIN">Projecteur A Dessin</option>
            <option value="TABLEAU d’ACTIVITE">Tableau D’Activite</option>
            <option value="AUTRES">Autres</option>
      
            </select>
      
            {:else if categorie == "AUDIO / VIDEO"}
            <select name="sub_categorie" id="sub_categorie" bind:value={sub_categorie}>
            <option value="CASQUE ENFANT">Casque Enfant</option>
            <option value="DVD">Dvd</option>
            <option value="INSTRUMENT EN BOIS">Instrument En Bois</option>
            <option value="INSTRUMENTS">Instruments</option>
            <option value="LECTEUR MUSIQUE">Lecteur Musique</option>
            <option value="MICRO">Micro</option>
            <option value="AUTRES">Autres</option>
            </select>
      
            {:else if categorie == "JEUX DE SOCIETE"}
            <select name="sub_categorie" id="sub_categorie" bind:value={sub_categorie}>
            <option value="1ER AGE">1Er Age</option>
            <option value="CARTE à COLLECTION">Carte À Collection</option>
            <option value="CARTE à JOUER">Carte À Jouer</option>
            <option value="CLASSIQUE">Classique</option>
            <option value="ENIGME / STRATEGIE">Enigme / Strategie</option>
            <option value="EXPERIENCE / SCIENCE">Experience / Science</option>
            <option value="JUNIOR">Junior</option>
            <option value="LOTO / DOMINO / MEMORY">Loto / Domino / Memory</option>
            <option value="TV / AMBIANCE">Tv / Ambiance</option>
            <option value="VOYAGE">Voyage</option>
            <option value="AUTRES">Autres</option>
            </select>
      
            {:else if categorie == "JEUX EDUCATIF"}
            <select name="sub_categorie" id="sub_categorie" bind:value={sub_categorie}>
            <option value="BILINGUE">Bilingue</option>
            <option value="COMPTER">Compter</option>
            <option value="FORME / COULEUR">Forme / Couleur</option>
            <option value="HEURE / TEMPS">Heure / Temps</option>
            <option value="LETTRE / CHIFFRE">Lettre / Chiffre</option>
            <option value="LIRE / ECRIRE">Lire / Ecrire</option>
            <option value="AUTRES">Autres</option>
            </select>
      
            {:else if categorie == "JEUX INTERACTIF"}
            <select name="sub_categorie" id="sub_categorie" bind:value={sub_categorie}>
            <option value="ANIMAUX">Animaux</option>
            <option value="APPAREIL PHOTO">Appareil Photo</option>
            <option value="APPRENTISSAGE">Apprentissage</option>
            <option value="CONSOLE 1ER AGE">Console 1Er Age</option>
            <option value="LIVRE MUSICAL">Livre Musical</option>
            <option value="OBJET CONNECTE">Objet Connecte</option>
            <option value="ORDINATEUR ENFANT">Ordinateur Enfant</option>
            <option value="RADIOTELECOMMANDE">Radiotelecommande</option>
            <option value="TABLETTE ENFANT">Tablette Enfant</option>
            <option value="AUTRES">Autres</option>
            </select>
      
            {:else if categorie == "JEUX PLEIN AIR"}
            <select name="sub_categorie" id="sub_categorie" bind:value={sub_categorie}>
            <option value="BILLES">Billes</option>
            <option value="CASQUE / PROTECTION">Casque / Protection</option>
            <option value="DRAISIENNE">Draisienne</option>
            <option value="PLAGE">Plage</option>
            <option value="QUILLE / PETANQUE">Quille / Petanque</option>
            <option value="RAQUETTE">Raquette</option>
            <option value="ROLLER">Roller</option>
            <option value="SKATE BOARD">Skate Board</option>
            <option value="TALKIE WALKIE">Talkie Walkie</option>
            <option value="TENTE">Tente</option>
            <option value="TRICYCLE / MOTO">Tricycle / Moto</option>
            <option value="TROTINETTE">Trotinette</option>
            <option value="VELO">Velo</option>
            <option value="AUTRES">Autres</option>
            </select>
      
            {:else if categorie == "JEUX D’IMITATION"}
            <select name="sub_categorie" id="sub_categorie" bind:value={sub_categorie}>
            <option value="ACC DEGUISEMENT ">Acc Deguisement </option>
            <option value="BRICOLAGE / JARDINAGE">Bricolage / Jardinage</option>
            <option value="CAISSE / MARCHANDE">Caisse / Marchande</option>
            <option value="CUISINE / DINETTE">Cuisine / Dinette</option>
            <option value="DEGUISEMENT FILLE">Deguisement Fille</option>
            <option value="DEGUISEMENT GARCON">Deguisement Garcon</option>
            <option value="METIERS">Metiers</option>
            <option value="SOIN DE LA MAISON">Soin De La Maison</option>
            <option value="AUTRES">Autres</option>
            </select>
      
            {:else if categorie == "JOUET 1ER AGE"}
            <select name="sub_categorie" id="sub_categorie" bind:value={sub_categorie}>
            <option value="ANIMAUX">Animaux</option>
            <option value="BOITE à FORME">Boite À Forme</option>
            <option value="BRIQUE / CONSTRUCTION">Brique / Construction</option>
            <option value="CHARIOT DE MARCHE">Chariot De Marche</option>
            <option value="HOCHET">Hochet</option>
            <option value="JEU d’ACTIVITE / EVEIL">Jeu D’Activite / Eveil</option>
            <option value="JOUET SONORE">Jouet Sonore</option>
            <option value="LOT 1ER AGE">Lot 1Er Age</option>
            <option value="MR PATATE">Mr Patate</option>
            <option value="PERSONNAGE">Personnage</option>
            <option value="PLAYMOBIL 1 2 3 ">Playmobil 1 2 3 </option>
            <option value="TABLEAU d’ACTIVITE">Tableau D’Activite</option>
            <option value="TAPIS d’EVEIL">Tapis D’Eveil</option>
            <option value="VEHICULE">Vehicule</option>
            <option value="AUTRES">Autres</option>
            </select>
      
      
            {:else if categorie == "JOUET EN BOIS"}
            <select name="sub_categorie" id="sub_categorie" bind:value={sub_categorie}>
            <option value="ANIMAUX">Animaux</option>
            <option value="ANIMAUX à TIRER">Animaux À Tirer</option>
            <option value="BOULIER">Boulier</option>
            <option value="CUBE">Cube</option>
            <option value="JEU d’ACTIVITE / EVEIL">Jeu D’Activite / Eveil</option>
            <option value="KAPLA / CONSTRUCTION">Kapla / Construction</option>
            <option value="PECHE à la LIGNE">Peche À La Ligne</option>
            <option value="PUZZLE / ENCASTREMENT">Puzzle / Encastrement</option>
            <option value="TRAIN / CIRCUIT">Train / Circuit</option>
            <option value="VEHICULE">Vehicule</option>
            <option value="AUTRES">Autres</option>
            </select>
      
            {:else if categorie == "LECTURE"}
            <select name="sub_categorie" id="sub_categorie" bind:value={sub_categorie}>
            <option value="1ER AGE">1Er Age</option>
            <option value="1ERE LECTURE">1Ere Lecture</option>
            <option value="BD">Bd</option>
            <option value="CAHIER JEUX / EXERCICES">Cahier Jeux / Exercices</option>
            <option value="CUISINE ENFANTS">Cuisine Enfants</option>
            <option value="DICTIONNAIRE">Dictionnaire</option>
            <option value="DOCUMENTAIRE ">Documentaire </option>
            <option value="EDUCATIF">Educatif</option>
            <option value="LIVRE à ACTIVITER">Livre À Activiter</option>
            <option value="LIVRE DE CONTE">Livre De Conte</option>
            <option value="LIVRE PUZZLE">Livre Puzzle</option>
            <option value="LOT max 5 livres">Lot Max 5 Livres</option>
            <option value="PUERICULTURE">Puericulture</option>
            <option value="RECETTE BEBE">Recette Bebe</option>
            <option value="ROMAN">Roman</option>
            <option value="AUTRES">Autres</option>
            </select>
      
            {:else if categorie == "PUZZLE"}
            <select name="sub_categorie" id="sub_categorie" bind:value={sub_categorie}>
            <option value="LIVRE PUZZLE">Livre Puzzle</option>
            <option value="PUZZLE">Puzzle</option>
            <option value="PUZZLE ENFANT">Puzzle Enfant</option>
            <option value="PUZZLE 3D">Puzzle 3D</option>
            <option value="PUZZLE EN BOIS">Puzzle En Bois</option>
            <option value="AUTRES">Autres</option>
            </select>
      
      
            {:else if categorie == "UNIVERS BEBE"}
            <select name="sub_categorie" id="sub_categorie" bind:value={sub_categorie}>
            <option value="ACC POUSSETTE">Acc Poussette</option>
            <option value="ANNEAU DE BAIN ">Anneau De Bain </option>
            <option value="BAIGNOIRE ET ACC">Baignoire Et Acc</option>
            <option value="CHANCELIERE">Chanceliere</option>
            <option value="ECHARPE DE PORTAGE">Echarpe De Portage</option>
            <option value="PARC ET ACC">Parc Et Acc</option>
            <option value="PORTE BEBE">Porte Bebe</option>
            <option value="POUSETTE / NACELLE">Pousette / Nacelle</option>
            <option value="REHAUSSEUR">Rehausseur</option>
            <option value="SAC à LANGER">Sac À Langer</option>
            <option value="SIEGE AUTO">Siege Auto</option>
            <option value="TRANSAT / BALANCELLE">Transat / Balancelle</option>
            <option value="VOYAGE">Voyage</option>
            <option value="AUTRES">Autres</option>
            </select>
      
            {:else if categorie == "UNIVERS BEBE NUIT"}
            <select name="sub_categorie" id="sub_categorie" bind:value={sub_categorie}>
            <option value="BABYPHONE">Babyphone</option>
            <option value="BALANCE BEBE">Balance Bebe</option>
            <option value="BARIERE DE LIT / SECURITE">Bariere De Lit / Securite</option>
            <option value="CALE BEBE">Cale Bebe</option>
            <option value="GIGOTEUSE">Gigoteuse</option>
            <option value="LIT PARAPLUIE">Lit Parapluie</option>
            <option value="MATELAS">Matelas</option>
            <option value="MOBILE">Mobile</option>
            <option value="POT DE CHAMBRE">Pot De Chambre</option>
            <option value="TABLE à LANGER">Table À Langer</option>
            <option value="VEILLEUSE">Veilleuse</option>
            <option value="AUTRES">Autres</option>
            </select>
      
            {:else if categorie == "UNIVERS BEBE REPAS"}
            <select name="sub_categorie" id="sub_categorie" bind:value={sub_categorie}>
            <option value="BABYCOOK">Babycook</option>
            <option value="BIBERON / ACC">Biberon / Acc</option>
            <option value="CHAISE HAUTE">Chaise Haute</option>
            <option value="CHAUFFE BIBERON">Chauffe Biberon</option>
            <option value="COUSSIN ALLAITEMENT">Coussin Allaitement</option>
            <option value="EGOUTTOIR">Egouttoir</option>
            <option value="VAISELLE">Vaiselle</option>
            <option value="STERILISATEUR">Sterilisateur</option>
            <option value="AUTRES">Autres</option>
            </select>
      
            {:else if categorie == "UNIVERS FILLE"}
            <select name="sub_categorie" id="sub_categorie" bind:value={sub_categorie}>
            <option value="ACC POUPEE">Acc Poupee</option>
            <option value="ANIMAUX">Animaux</option>
            <option value="BARBIE / ACC">Barbie / Acc</option>
            <option value="BERCEAU / POUSSETTE">Berceau / Poussette</option>
            <option value="FIGURINE">Figurine</option>
            <option value="LEGO FRIENDS">Lego Friends</option>
            <option value="LOL SURPRISE">Lol Surprise</option>
            <option value="MAISON / ACC">Maison / Acc</option>
            <option value="NERF REBELLE">Nerf Rebelle</option>
            <option value="NURSERIE / ACC">Nurserie / Acc</option>
            <option value="PET SHOP">Pet Shop</option>
            <option value="PINYPON">Pinypon</option>
            <option value="POUPEE / POUPON">Poupee / Poupon</option>
            <option value="REINE DES NEIGES">Reine Des Neiges</option>
            <option value="ZHUZHU PET">Zhuzhu Pet</option>
            <option value="AUTRES">Autres</option>
            </select>
      
            {:else if categorie == "UNIVERS GARCON"}
            <select name="sub_categorie" id="sub_categorie" bind:value={sub_categorie}>
            <option value="ANIMAUX">Animaux</option>
            <option value="BEYBLADE">Beyblade</option>
            <option value="CIRCUIT">Circuit</option>
            <option value="CONSTRUCTION">Construction</option>
            <option value="FIGURINE">Figurine</option>
            <option value="GARAGE">Garage</option>
            <option value="HARRY POTTER">Harry Potter</option>
            <option value="LEGO">Lego</option>
            <option value="MECCANO">Meccano</option>
            <option value="NERF">Nerf</option>
            <option value="PLAYMOBIL">Playmobil</option>
            <option value="POKEMON">Pokemon</option>
            <option value="TRANSFORMERS">Transformers</option>
            <option value="VEHICULE">Vehicule</option>
            <option value="AUTRES">Autres</option>
            </select>
      
      
            {/if}
            <input type="text" class="inputt" maxlength="15" placeholder="Nom de l'article" bind:value={name}>
            <textarea type="text" rows="3" maxlength="50" cols="30" style='outline:none;color:white;width : 65%;border:none;border-bottom:3px solid white;resize:none;background-color: transparent;' placeholder="Bref descriptif" bind:value={descriptif}></textarea>
            <input type="number" class="inputt" min="0" placeholder="Prix" step=".5" bind:value={prix}>
            <div class="submit" on:click={editJouetGood}>MODIFIER</div>
          </form>
        </div>
        </div>

       
</main>

<style>
main{
    width: 100vw;
    min-height: 100vh;
    background-color: #262626;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: white;
    }

    .apply{
      cursor: pointer;
      user-select: none;
    }

    .apply:hover{
      transform: scale(1.2);
    }

  .cardUser{
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 10vw;
    padding: 10px;
    font-size: 2rem;
    color: black;
    border-radius: 15px;
    margin: 2vh;
    font-weight: 600;
    cursor: pointer;
    user-select: none;
  }

  .cardUser:hover{
    transform: scale(1.05);
  }

  .red{
    background-color: lightcoral;
  }

  .green{
    background-color: lightgreen;
  }

  .orange{
    background-color: lightsalmon;
  }


  .users{
    width: 20vw;
    height: 80vh;
    overflow: auto;
    position: fixed;
    top:20vh;
    left: 0;
  }

  .usersbtn{
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .cont{
    width: 80vw;
    height: fit-content;
    display: flex;
    flex-direction: column;
  }

  .btn-cancel{
      user-select: none;
        cursor: pointer;
        width: fit-content;
        height: fit-content;
        border-radius: 15px;
        color: white;
        font-size: 1.2rem;
        margin: 15px;
        font-weight: 400;
        padding: 15px;
        background-color:#d14d2c ;
        box-shadow: 0px 0px 30px -10px #ba3817;
        transition: ease-in-out .25s;
        user-select: none;
        font-family: 'Poppins', sans-serif;
        font-weight: 400;
        text-align: center;
        border: none;
    }
    .btn-cancel:hover{
      transform: scale(1.08);
    }

  .infos{
    width: 80%;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }

  .jouetsContainer{
    width: 80vw;
    height: fit-content;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .formjouet{
      z-index: 10;
      height: 70vh;
      width: 20vw;
      background-color: #262626;
      box-shadow:  10px 10px 25px #151515,
         -10px -10px 25px #373737;
      border-radius: 20px;
      display: flex;
      flex-direction: column;
      right: 3vw;
      align-items: center;
      justify-content: space-evenly;
    }

  .elm{ 
        color: white;
        margin-right: 20px;
        cursor: pointer;
        font-weight: 700;
    }

    .filters{
      display: flex;
      justify-content: space-evenly;
      height: 5vh;
      width: 20vw;
      position: fixed;
      left: 0;
    }

    .elm:hover{
        color: #507DBC ;
        text-decoration: none;
    }
    .cache{
      width: 100vw;
      min-height: 15vh;
    }
    /*.container{
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
    }*/

    .btn-stat{
      user-select: none;
        cursor: pointer;
        width: 8vw;
        height: fit-content;
        border-radius: 15px;
        color: white;
        font-size: 1.2rem;
        margin: 15px;
        font-weight: 400;
        padding: 15px;
        animation: glow 3s ease-in infinite;
        box-shadow: 0px 0px 30px -10px #7A9CCD;
        transition: ease-in-out .25s;
        user-select: none;
        font-family: 'Poppins', sans-serif;
        font-weight: 400;
        text-align: center;
        border: none;
    }
    .btn-stat:hover{
      transform: scale(1.08);
    }
    @keyframes glow {
  0% {
    background: #507DBC;
  }
  25% {
    background: #6785af;
  }
  100% {
    background: #507DBC;
  }
}

  .stats{
    display: flex;
    width: 80vw;
    height: 85vh;
    flex-direction: column;
    justify-content: center;
    padding-left: 20vw;
}

  .stat{
    font-size: 1.5rem;
    font-family: 'Poppins', sans-serif;
    font-weight: 400;
  }

  .cacheform{
      width: 100vw;
      min-height: 100vh;
      position: fixed;
      top:0;
      left:0;
      background-color: rgba(0,0, 0, 0.6);
      display: none;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    .inputt{
        padding: 10px;
        background-color: transparent;
        margin: 20px;
        height: 5vh;
        outline: none;
        border:none;
        border-bottom: 3px solid white;
        color: white;
        width : 65%;

    }

    form{
      display: flex;
         flex-direction: column;
         align-items: center;
         justify-content: space-around;
    }
    .submit{
      user-select: none;
        cursor: pointer;
        width: fit-content;
        height: fit-content;
        border-radius: 15px;
        color: white;
        font-size: 1.2rem;
        margin: 15px;
        font-weight: 400;
        padding: 15px;
        animation: glow 3s ease-in infinite;
        box-shadow: 0px 0px 30px -10px #7A9CCD;
        transition: ease-in-out .25s;
        user-select: none;
        font-family: 'Poppins', sans-serif;
        font-weight: 400;
        text-align: center;
        border: none;
    }

</style>